"use strict";

import React from "react";

import ButtonBar from "./base/ButtonBar";

class PreviewPanelFooter extends React.Component {
  render() {
    return (
      <ButtonBar align="center" className="si-c-preview-panel__footer">
        {this.props.children}
      </ButtonBar>
    );
  }
}

export default PreviewPanelFooter;
